// extracted by mini-css-extract-plugin
export default {"form":"KSpK1ZY6D2d__d3D7HvI","intro":"zDKjNEd0Ua2IycKV76Ta"};